<template>
  <form class="flex flex-col gap-4 pb-10 w-full text-left">
    <div class="flex flex-row gap-4 items-center justify-between">
      <h5 class="codigo-exportacion">Nuevo Contenedor</h5>
      <div class="text-right">
        <button class="btn-principal" type="button" @click="agregarContendor()">
          <fas :icon="['fas', 'plus']"></fas>
          Agregar
        </button>
      </div>
    </div>
    <div
      class="flex flex-col gap-4"
      :key="index"
      v-for="(contenedor, index) in form"
    >
      <div class="flex flex-col justify-between gap-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
          <!--- CONTENEDOR -->
          <div v-if="caracteristica_carga == 'CONTENEDOR'">
            <label> Variedad </label>
            <select
              :id="contenedor.id + '-variedad-select'"
              v-model="contenedor.variedad"
              required
            >
              <option value="0" disabled>Selecciona el Tipo de Variedad</option>
              <option
                :key="index"
                v-for="(variedad, index) in variedades"
                :value="variedad"
              >
                {{ variedad }}
              </option>
            </select>
          </div>

          <div v-if="caracteristica_carga == 'CONTENEDOR'">
            <label>Identificador</label>
            <input
              type="text"
              v-model="contenedor.identificacion"
              :maxlength="255"
              required
            />
          </div>
          <!--- CONTENEDOR -->

          <!--- CARGA SUELTA -->

          <div v-if="caracteristica_carga == 'CARGA SUELTA'">
            <label>Bultos</label>
            <input
              type="text"
              v-model="contenedor.bultos"
              :maxlength="255"
              required
            />
          </div>
          <div v-if="caracteristica_carga == 'CARGA SUELTA'">
            <label>Kilos</label>
            <input
              type="text"
              v-model="contenedor.kilos"
              :maxlength="255"
              required
            />
          </div>
          <div v-if="caracteristica_carga == 'CARGA SUELTA'">
            <label>CBM</label>
            <input
              type="text"
              v-model="contenedor.CBM"
              :maxlength="255"
              required
            />
          </div>

          <!--- CARGA SUELTA -->

          <!--- VEHÍCULOS -->
          <div v-if="caracteristica_carga == 'VEHÍCULOS'">
            <label>Cantidad de Vehículos</label>
            <input
              type="text"
              v-model="contenedor.cantidad"
              :maxlength="255"
              required
            />
          </div>
          <!--- VEHÍCULOS -->

          <!--- FIERROS -->
          <div v-if="caracteristica_carga == 'FIERROS'">
            <label>Cantidad de Fierros</label>
            <input
              type="text"
              v-model="contenedor.cantidad"
              :maxlength="255"
              required
            />
          </div>
          <!--- FIERROS -->

          <!--- GRANELES -->
          <div v-if="caracteristica_carga == 'GRANELES'">
            <label>Volumen</label>
            <input
              type="text"
              v-model="contenedor.volumen"
              :maxlength="255"
              required
            />
          </div>
          <!--- GRANELES -->

          <div sm="12" md="12" lg="4">
            <label>Fecha de Retiro</label>
            <b-form-datepicker
              label-next-month="Siguiente mes"
              label-next-year="Siguiente año"
              label-current-month="Mes actual"
              label-prev-year="Año anterior"
              label-prev-month="Mes anterior"
              label-prev-decade="Decada anterior"
              label-next-decade="Decada siguiente"
              label-no-date-selected="No hay fecha seleccionada"
              label-help="Usa el cursos para navegar por las fechas"
              v-model="contenedor.fecha_retiro"
            ></b-form-datepicker>
          </div>
          <div sm="12" md="12" lg="3">
            <label>Hora de Retiro</label>
            <b-form-timepicker
              label-no-time-selected="No hay hora seleccionada"
              label-close-button="Cerrar"
              label-hours="Horas"
              label-minutes="Minutes"
              v-model="contenedor.hora_retiro"
              locale="es"
            ></b-form-timepicker>
          </div>
          <div>
            <label>Patente Transporte</label>
            <input
              type="text"
              v-model="contenedor.patente"
              :maxlength="255"
              required
            />
          </div>
          <div>
            <label> Asociar Guía Despacho </label>

            <select
              id="guia_despacho-select"
              v-model="contenedor.documentos_id"
              required
            >
              <option value="0" disabled>
                Selecciona el Guia de Despacho Asociado
              </option>
              <option
                :key="index"
                v-for="(documento, index) in documentos"
                :value="documento.id"
              >
                {{ documento.base ? documento.base.numero_guia_despacho : "" }}
                - {{ documento.tipo.nombre }}
              </option>
            </select>
          </div>
          <div>
            <label> Asociar Pago </label>

            <select
              id="agente_cargas-select"
              v-model="contenedor.pagos_id"
              required
            >
              <option value="0" disabled>Selecciona el Pago Asociado</option>
              <option
                :key="index"
                v-for="(pago, index) in pagos"
                :value="pago.id"
              >
                {{ pago.tipo.nombre }} -
                {{ moment(pago.fecha_pago).format("DD-MM-YYYY") }}
              </option>
            </select>
          </div>
        </div>
        <div class="flex flex-row justify-end items-center">
          <button
            v-if="index > 0"
            class="btn-secundario ml-auto"
            type="button"
            @click="borrarContenedor(contenedor.id)"
          >
            <inline-svg
              class="icono-titulo"
              src="../../assets/images/basura.svg"
              title="My Image"
            />
            Quitar
          </button>
        </div>
      </div>
      <hr />
    </div>

    <div class="flex flex-row items-center justify-end">
      <button
        class="btn-principal btn-large"
        type="button"
        @click="postContenedor()"
      >
        Enviar Formulario
      </button>
    </div>
  </form>
</template>

<script>
import moment from "moment";
import axios from "axios";
export default {
  props: {
    caracteristica_carga: String,
    form: Array,
    agregarContendor: Function,
    borrarContenedor: Function,
    postContenedor: Function,

    variedades: Array,
    pagos: Array,
    documentos: Array,
  },
  data() {
    return {
      file: [],
      variedad_id: "",

      idContenedor: "",
    };
  },
  mounted() {},
  methods: {
    eliminar(id, file) {
      this.form.forEach((el) => {
        if (el.id == id) {
          let files = [];
          el.archivos.forEach((arc) => {
            console.log(arc.name == file.name);
            if (arc.name != file.name) files.push(arc);
          });
          el.archivos = files;
        }
      });
    },
    documento(id) {
      this.idContenedor = id;
    },
  },
};
</script>

<style></style>
